module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0002.jpg?v=8c98d6ec";